import { IMG } from "@/lib/site";

const R = (title, to, desc) => ({ title, to, desc });

export const pagesB = [
  {
    slug: "/eisbeseitigung-bremen",
    title: "Eisbeseitigung Bremen | Glätte & Eis entfernen",
    description:
      "Eisbeseitigung in Bremen: Eis auf Gehweg, Treppen und Eingängen entfernen, Glatteis bekämpfen. Professionelle Glättebeseitigung für Privat und Gewerbe.",
    label: "/ Eisbeseitigung",
    service: "Eisbeseitigung Bremen",
    h1Lines: ["Eisbeseitigung Bremen –", "wenn Glätte schon", "festgefroren ist."],
    intro:
      "Nicht jede Glätte lässt sich wegschieben. Festgefrorene Schneereste, Eisplatten an Treppen und Eis vor Eingangstüren brauchen eine andere Behandlung. Wir beseitigen Eis an den kritischen Punkten Ihres Objekts in Bremen.",
    image: IMG.nightStreet,
    sections: [
      {
        h2: "Wie Eis auf Wegen und Flächen entsteht",
        p: [
          "Eis auf Gehwegen und Hofflächen entsteht in Bremen meist nicht durch Schneefall, sondern durch Wasser. Regen oder Tauwasser läuft über die Fläche, sammelt sich in Senken, an Kanten und vor Türschwellen – und friert bei fallender Temperatur zu einer tragfähigen Platte. Ein zweiter Entstehungsweg ist verdichteter Schnee: Wird eine Schneedecke betreten oder befahren, presst sich die Schicht zusammen und bindet an den Untergrund.",
          "Besonders kritisch sind Nordseiten von Gebäuden, überdachte Zonen, in denen kein Streusalz hinkommt, aber Zugluft weht, sowie Treppenwangen und Rampen mit Gefälle. Dort hält sich Eis oft noch Tage, nachdem die Hauptfläche länger abgetaut ist.",
        ],
      },
      {
        h2: "Das Problem: Eis ist unsichtbar und stabil",
        p: [
          "Eine klare Eisschicht auf dunklem Pflaster wird häufig erst erkannt, wenn man schon darauf steht. Zudem lässt sie sich nicht mit normalem Streugut in kurzer Zeit auflösen – Sand erhöht nur die Griffigkeit, löst das Eis aber nicht. Wer mit Gewalt arbeitet, beschädigt Pflaster, Fliesen, Treppenkanten oder Metallprofile.",
          "Für Eigentümer und Betriebe ist Eis deshalb das größte Haftungsrisiko im Winter: Die meisten Sturzunfälle auf Grundstücken passieren an Treppen, Eingängen und auf kleinen, scheinbar harmlosen Eisflächen.",
        ],
      },
      {
        h2: "Die Lösung: mechanisch lösen, gezielt behandeln, nachkontrollieren",
        p: [
          "Wir kombinieren mechanisches Lösen mit einer gezielten Behandlung der Fläche. Dabei achten wir auf den Belag: Naturstein, Klinker, Betonwerkstein und Fliesen reagieren unterschiedlich auf Werkzeug und Streumittel. Anschließend wird die Fläche so abgestreut, dass sie griffig bleibt, bis das Eis vollständig weg ist.",
        ],
        bullets: [
          "Eisplatten an Treppen und Podesten lösen",
          "Eingangsbereiche und Türschwellen freimachen",
          "Festgefahrene Schnee- und Eisschichten aufbrechen",
          "Rampen und Gefällestrecken behandeln",
          "Entwässerungspunkte freiräumen, damit Wasser abläuft",
          "Nachkontrolle bei anhaltendem Frost",
        ],
      },
      {
        h2: "Vorbeugen ist günstiger als beseitigen",
        p: [
          "Eisbeseitigung ist aufwendiger als Glättevorbeugung. Deshalb ist die wirksamste Maßnahme ein funktionierender Streudienst, der vor der Glättebildung aktiv wird, zusammen mit einer Fläche, auf der Wasser ablaufen kann. Wir weisen bei der Objektaufnahme darauf hin, wo sich regelmäßig Wasser sammelt – oft lässt sich die Ursache mit wenig Aufwand entschärfen.",
        ],
      },
    ],
    steps: [
      { t: "Begutachtung", d: "Wo entsteht Eis, und warum – Gefälle, Entwässerung, Schatten." },
      { t: "Lösen", d: "Mechanisches Aufbrechen belagsgerecht, ohne Schäden." },
      { t: "Behandeln", d: "Fläche abstreuen oder auftauend behandeln – je nach Belag." },
      { t: "Kontrolle", d: "Nachkontrolle, solange Frost und Nässe anhalten." },
    ],
    objects: [
      "Treppenanlagen und Außenstufen",
      "Haus- und Betriebseingänge",
      "Rampen und Behindertenzugänge",
      "Tiefgaragenrampen",
      "Innenhöfe und Durchgänge",
      "Gehwegabschnitte mit Senken",
    ],
    local:
      "In Bremen folgen auf milde, nasse Tage oft klare Frostnächte. Genau diese Abfolge erzeugt Glatteis auf vorher nur feuchten Flächen. In Wassernähe – an der Weser, an der Lesum und in den Niederungen – ist die Luftfeuchte zusätzlich hoch, was Reifglätte begünstigt.",
    faq: [
      { q: "Können Sie auch festgefrorenes Eis entfernen?", a: "Ja. Wir lösen Eisschichten mechanisch und behandeln die Fläche anschließend, damit sie griffig bleibt." },
      { q: "Werden Pflaster oder Fliesen dabei beschädigt?", a: "Wir arbeiten belagsgerecht und wählen Werkzeug und Streumittel entsprechend. Bei empfindlichen Belägen gehen wir bewusst vorsichtiger und dafür in mehreren Schritten vor." },
      { q: "Kommen Sie auch für einen einzelnen Eis-Einsatz?", a: "Ja, Einzeleinsätze sind nach Verfügbarkeit möglich – etwa nach einer Glatteisnacht." },
      { q: "Was ist besser: Salz oder Sand gegen Eis?", a: "Zum Lösen von Eis wirkt auftauendes Streumittel, Sand verbessert nur die Griffigkeit. Welche Variante eingesetzt wird, hängt von Fläche, Belag und Umgebung ab." },
      { q: "Übernehmen Sie das dauerhaft über den Winter?", a: "Ja, als Teil der Saisonbetreuung inklusive Streudienst und Schneeräumung." },
    ],
    related: [
      R("Streudienst Bremen", "/streudienst-bremen", "Glätte vorbeugen statt beseitigen."),
      R("Treppen & Eingänge", "/treppen-winterdienst-bremen", "Kritischste Punkte am Objekt."),
      R("Schneeräumung Bremen", "/schneeraeumung-bremen", "Bevor Schnee zu Eis wird."),
      R("Gehweg-Winterdienst", "/gehweg-winterdienst-bremen", "Eis auf dem Gehweg."),
      R("Winterdienst Bremen", "/winterdienst-bremen", "Komplettleistung im Überblick."),
      R("24/7-Bereitschaft", "/winterdienst-24-7-bremen", "Nachts einsatzbereit."),
    ],
  },

  {
    slug: "/parkplatz-winterdienst-bremen",
    title: "Parkplatz Winterdienst Bremen | Parkflächen & Parkhäuser räumen",
    description:
      "Parkplatz-Winterdienst in Bremen: Parkplätze räumen, Parkhäuser und Parkdecks vom Schnee befreien, Rampen streuen. Winterdienst für Parkflächen – Angebot auf Anfrage.",
    label: "/ Parkplätze",
    service: "Parkplatz Winterdienst Bremen",
    h1Lines: ["Parkplatz-Winterdienst", "Bremen – Stellflächen", "nutzbar halten."],
    intro:
      "Ein nicht geräumter Parkplatz kostet Stellplätze, Zeit und im Zweifel die Verkehrssicherheit. Wir räumen und streuen Kundenparkplätze, Mitarbeiterstellflächen, Parkdecks, Rampen und Parkhauszufahrten in Bremen.",
    image: IMG.parkingLot,
    sections: [
      {
        h2: "Parkflächen sind der anspruchsvollste Teil des Winterdienstes",
        p: [
          "Auf einer Parkfläche kommen mehrere Schwierigkeiten zusammen: Die Fläche ist groß, sie ist teilweise mit Fahrzeugen belegt, sie hat Markierungen und Begrenzungen, und sie muss zu genau definierten Zeiten nutzbar sein. Dazu kommt Verkehr in zwei Richtungen – Fahrzeuge und Fußgänger, die zwischen den Reihen unterwegs sind.",
          "Wir planen Parkplatzeinsätze deshalb in Zonen und Reihenfolgen. Zuerst die Zufahrt und die Fahrgassen, dann die Stellplatzreihen, zuletzt die Nebenflächen wie Fahrradabstellplätze, Müllstandort und Wege zum Eingang. So bleibt die Fläche zu jedem Zeitpunkt nutzbar, auch während der Räumung.",
        ],
      },
      {
        h2: "Das Problem: Wohin mit dem Schnee?",
        p: [
          "Auf Parkplätzen entscheidet die Schneelagerung über den Erfolg. Wird der Schnee an den Rand geschoben, verliert man die äußeren Stellplätze. Wird er mittig aufgehäuft, blockiert er Fahrgassen und Sichtachsen. Landet er auf Gullys, fließt Tauwasser nicht ab – und gefriert nachts als Platte auf der Fahrfläche.",
          "Hinzu kommt: Stehen Fahrzeuge auf der Fläche, kann nicht flächig geräumt werden. Entweder bleiben Inseln stehen, die später zu Eis werden, oder es wird in mehreren Durchgängen gearbeitet.",
        ],
      },
      {
        h2: "Die Lösung: Zonenplan, Schneelager und Nacharbeit",
        p: [
          "Vor der Saison legen wir Schneelagerflächen fest, die keine Stellplätze und keine Entwässerung blockieren, und definieren Prioritätszonen. Bei Bedarf arbeiten wir in zwei Durchgängen: erst die freien Bereiche, später die Stellplätze, die zwischenzeitlich frei geworden sind. Bei großen Schneemengen organisieren wir auf Absprache den Abtransport.",
        ],
        bullets: [
          "Zufahrten und Fahrgassen zuerst freihalten",
          "Stellplatzreihen räumen – auch in mehreren Durchgängen",
          "Rampen und Gefällestrecken intensiv streuen",
          "Parkdecks und Parkhausebenen behandeln",
          "Wege vom Parkplatz zum Eingang mit erfassen",
          "Entwässerungspunkte freihalten",
          "Abtransport großer Schneemengen auf Absprache",
        ],
      },
      {
        h2: "Parkhäuser und Parkdecks",
        p: [
          "Bei Parkhäusern liegt das Risiko an den Übergängen: die Einfahrtsrampe, das offene oberste Deck und die Fußgängerausgänge. Rampen sind besonders kritisch, weil Fahrzeuge dort anfahren und bremsen müssen. Offene Parkdecks verhalten sich wie Freiflächen, haben aber oft begrenzte Möglichkeiten zur Schneelagerung – hier ist Abtransport häufiger notwendig. Zusätzlich muss die Streumittelwahl auf die Bausubstanz abgestimmt werden, um Beton und Bewehrung nicht unnötig zu belasten.",
        ],
      },
    ],
    steps: [
      { t: "Flächenaufnahme", d: "Größe, Zonen, Gullys, Rampen und Engstellen erfassen." },
      { t: "Zonenplan", d: "Prioritäten und Schneelagerflächen festlegen." },
      { t: "Räumen", d: "Zufahrt, Fahrgassen, Stellplatzreihen, Nebenflächen." },
      { t: "Streuen", d: "Rampen, Gefälle und Fußgängerquerungen behandeln." },
      { t: "Nacharbeit", d: "Zweiter Durchgang für zwischenzeitlich frei gewordene Plätze." },
    ],
    objects: [
      "Kundenparkplätze im Handel",
      "Mitarbeiterparkplätze",
      "Parkhäuser und Parkdecks",
      "Tiefgaragenrampen",
      "Besucherparkflächen an Bürogebäuden",
      "Stellflächen an Wohnanlagen",
    ],
    local:
      "Parkflächen gehören in Bremen zu fast jedem Gewerbeobjekt – von den Handelsstandorten und Fachmärkten über die Bürostandorte in Mitte und der Überseestadt bis zu den Betriebsgeländen in Hemelingen, Sebaldsbrück, Walle und Bremen-Nord. Wir räumen sie im Stadtgebiet und im direkten Umland.",
    faq: [
      { q: "Räumen Sie auch, wenn Fahrzeuge auf der Fläche stehen?", a: "Ja. Wir räumen die freien Bereiche und arbeiten in einem zweiten Durchgang nach, wenn Stellplätze frei geworden sind." },
      { q: "Können Sie Schnee vom Parkplatz abtransportieren?", a: "Bei großen Mengen ist Abtransport auf Absprache möglich, wenn keine geeignete Lagerfläche vorhanden ist." },
      { q: "Werden Parkhausrampen mit behandelt?", a: "Ja. Rampen sind der kritischste Punkt und werden besonders sorgfältig gestreut." },
      { q: "Wird auch der Weg zum Eingang geräumt?", a: "Auf Wunsch ja. Gehwege und Fußgängerquerungen auf dem Gelände nehmen wir mit in den Räumplan." },
      { q: "Wie wird die Leistung dokumentiert?", a: "Auf Wunsch mit Datum, Uhrzeit und ausgeführter Leistung je Einsatz." },
    ],
    related: [
      R("Winterdienst Gewerbe", "/winterdienst-bremen-gewerbe-hausverwaltung", "Verkehrssicherung für Betriebe."),
      R("Gewerbeimmobilien", "/winterdienst-gewerbeimmobilien", "Objektbetreuung im Winter."),
      R("Zufahrten", "/zufahrten-winterdienst-bremen", "Einfahrten und Rampen."),
      R("Streudienst Bremen", "/streudienst-bremen", "Glätte auf Fahrflächen."),
      R("Schneeräumung Bremen", "/schneeraeumung-bremen", "Räumtechnik und Handarbeit."),
      R("24/7-Bereitschaft", "/winterdienst-24-7-bremen", "Vor Schichtbeginn geräumt."),
    ],
  },

  {
    slug: "/winterdienst-gewerbeimmobilien",
    title: "Winterdienst für Gewerbeimmobilien Bremen | Büro, Industrie, Handel",
    description:
      "Winterdienst für Gewerbeimmobilien in Bremen: Bürogebäude, Firmengebäude, Industrie- und Handelsobjekte räumen und streuen. Für Eigentümer und Verwaltungen.",
    label: "/ Gewerbeimmobilien",
    service: "Winterdienst Gewerbeimmobilien Bremen",
    h1Lines: ["Winterdienst für", "Gewerbeimmobilien", "in Bremen."],
    intro:
      "Bürogebäude, Firmengebäude, Industrie- und Handelsobjekte haben im Winter viele kritische Punkte: Zufahrt, Parkfläche, Haupteingang, Nebeneingänge, Laderampe, Fluchtwege. Wir betreuen diese Flächen als Gesamtpaket.",
    image: IMG.bremenFacade,
    sections: [
      {
        h2: "Objektbetreuung statt Einzelmaßnahme",
        p: [
          "Eine Gewerbeimmobilie ist im Winter kein einzelner Weg, sondern ein Netz von Flächen mit unterschiedlichen Anforderungen. Der Haupteingang muss repräsentativ und sicher sein, bevor der erste Besucher kommt. Die Laderampe muss zur Anlieferung frei sein. Fluchtwege und Notausgänge müssen unabhängig vom Betriebsablauf nutzbar bleiben. Der Mitarbeiterparkplatz braucht ein anderes Zeitfenster als der Besucherbereich.",
          "Wir gehen das Objekt deshalb einmal komplett durch und ordnen jede Fläche einer Priorität und einem Zeitfenster zu. Das Ergebnis ist ein Räum- und Streuplan, der die Immobilie als Ganzes abdeckt – und nicht nur das, was von der Straße aus sichtbar ist.",
        ],
      },
      {
        h2: "Das Problem: geteilte Verantwortung und viele Schnittstellen",
        p: [
          "Bei Gewerbeimmobilien ist oft unklar, wer welche Fläche verantwortet: Eigentümer, Verwaltung, Mieter, Facility-Dienstleister. In der Praxis führt das dazu, dass Randflächen – Nebeneingänge, Müllstandort, Fahrradstellplätze, Fluchttüren – übersehen werden. Genau dort passieren Unfälle.",
          "Dazu kommt die Nachweisfrage. Kommt es zu einem Sturz, muss belegbar sein, dass geräumt und gestreut wurde. Ohne Dokumentation ist das schwierig.",
        ],
      },
      {
        h2: "Die Lösung: ein Plan, ein Ansprechpartner, Nachweise",
        p: [
          "Wir übernehmen den Winterdienst für das gesamte Außengelände und halten schriftlich fest, welche Flächen enthalten sind. Als Ansprechpartner steht Inhaber Adil Altun direkt zur Verfügung – ohne Ticketsystem und ohne Zwischenstellen. Einsätze dokumentieren wir auf Wunsch je Termin.",
        ],
        bullets: [
          "Haupteingang, Nebeneingänge und Fluchtwege",
          "Zufahrten, Laderampen und Wendeflächen",
          "Mitarbeiter- und Besucherparkplätze",
          "Gehwege entlang des Grundstücks",
          "Treppen, Rampen und Außenaufzüge",
          "Müllstandort und Fahrradabstellplätze",
          "Einsatzdokumentation für Verwaltung und Versicherung",
        ],
      },
      {
        h2: "Zusammenarbeit mit Verwaltungen und Facility-Dienstleistern",
        p: [
          "Viele Anfragen kommen von Hausverwaltungen und Facility-Dienstleistern, die für mehrere Objekte in Bremen zuständig sind. Für diese Auftraggeber ist vor allem wichtig, dass Absprachen eingehalten werden und Rückfragen direkt geklärt werden können. Genau das ist der Vorteil eines regionalen Betriebs mit einem festen Ansprechpartner.",
        ],
      },
    ],
    steps: [
      { t: "Objektbegehung", d: "Alle Außenflächen aufnehmen, Zuständigkeiten klären." },
      { t: "Prioritäten", d: "Zeitfenster je Fläche festlegen – Eingang, Rampe, Parkplatz." },
      { t: "Räum- und Streuplan", d: "Schriftlicher Leistungsumfang und Angebot." },
      { t: "Saisonbetrieb", d: "Bereitschaft, Einsätze, Nacharbeit." },
      { t: "Nachweis", d: "Dokumentation je Einsatz auf Wunsch." },
    ],
    objects: [
      "Bürogebäude und Verwaltungsstandorte",
      "Firmengebäude und Betriebsgelände",
      "Industrie- und Produktionsstandorte",
      "Handelsobjekte und Fachmärkte",
      "Logistik- und Lagerflächen",
      "Ärztehäuser und Dienstleistungszentren",
    ],
    local:
      "Wir betreuen Gewerbeimmobilien im Bremer Stadtgebiet – von Hemelingen, Sebaldsbrück und Hastedt über Mitte, Überseestadt und Walle bis Gröpelingen, Burglesum und Bremen-Nord. Die Nähe zu unserem Firmensitz an der Flughafenallee ist dabei ein praktischer Vorteil bei kurzfristigen Einsätzen.",
    faq: [
      { q: "Übernehmen Sie das komplette Außengelände?", a: "Ja. Wir nehmen alle Außenflächen auf und halten im Angebot fest, welche davon enthalten sind." },
      { q: "Arbeiten Sie mit Hausverwaltungen zusammen?", a: "Ja. Wir betreuen Objekte im Auftrag von Verwaltungen, Eigentümern und Facility-Dienstleistern." },
      { q: "Werden Fluchtwege mit berücksichtigt?", a: "Ja. Notausgänge und Fluchtwege gehören zu den Flächen, die unabhängig von der Hauptnutzung freigehalten werden." },
      { q: "Gibt es eine Einsatzdokumentation?", a: "Auf Wunsch dokumentieren wir jeden Einsatz mit Datum, Uhrzeit und Leistung." },
      { q: "Betreuen Sie mehrere Objekte eines Auftraggebers?", a: "Ja, sofern sie im Bremer Stadtgebiet oder direkten Umland liegen und sich die Touren sinnvoll planen lassen." },
    ],
    related: [
      R("Winterdienst Gewerbe", "/winterdienst-bremen-gewerbe-hausverwaltung", "Grundlagen für Unternehmen."),
      R("Parkplatz-Winterdienst", "/parkplatz-winterdienst-bremen", "Parkflächen und Parkdecks."),
      R("Wohnimmobilien", "/winterdienst-immobilien-bremen", "Verwaltungsbestand entlasten."),
      R("Zufahrten", "/zufahrten-winterdienst-bremen", "Rampen und Anlieferung."),
      R("Treppen & Eingänge", "/treppen-winterdienst-bremen", "Repräsentative Zugänge."),
      R("24/7-Bereitschaft", "/winterdienst-24-7-bremen", "Vor Betriebsbeginn geräumt."),
    ],
  },

  {
    slug: "/winterdienst-bremen-umgebung",
    title: "Winterdienst Bremen & Umgebung | Stadtgebiet und Umland",
    description:
      "Winterdienst in Bremen und Umgebung: Schneeräumung, Streudienst und Eisbeseitigung im gesamten Bremer Stadtgebiet und im direkten Umland. Angebot auf Anfrage.",
    label: "/ Bremen & Umgebung",
    service: "Winterdienst Bremen und Umgebung",
    h1Lines: ["Winterdienst Bremen", "& Umgebung – Stadtgebiet", "und direktes Umland."],
    intro:
      "Unser Einsatzgebiet ist das Bremer Stadtgebiet mit allen Stadtteilen sowie das direkt angrenzende Umland. Wir nennen bewusst nur Gebiete, die wir tatsächlich bedienen – alles Weitere klären wir im Gespräch.",
    image: IMG.bremenMarket,
    sections: [
      {
        h2: "Ein Einsatzgebiet, das wirklich bedient wird",
        p: [
          "Viele Winterdienst-Anbieter listen lange Ortsnamen auf, die mit der tatsächlichen Einsatzplanung nichts zu tun haben. Wir machen das nicht. Unser Kerngebiet ist Bremen: von Mitte, Neustadt und der Östlichen Vorstadt über Findorff, Walle, Gröpelingen und Schwachhausen bis Horn-Lehe, Oberneuland, Borgfeld, Hemelingen, Sebaldsbrück, Vahr, Osterholz, Obervieland, Huchting, Woltmershausen, Burglesum, Vegesack und Blumenthal.",
          "Hinzu kommt das direkt angrenzende Umland. Ob ein Objekt dort wirtschaftlich und zeitlich sinnvoll zu betreuen ist, hängt von Lage, Fläche und Tourenplanung ab. Das sagen wir Ihnen bei der Anfrage offen – lieber eine klare Absage als eine Zusage, die im Januar um sechs Uhr morgens nicht hält.",
        ],
      },
      {
        h2: "Das Problem: Winterdienst ist Logistik",
        p: [
          "Winterdienst funktioniert nur über Touren. Jedes Objekt braucht ein Zeitfenster, und zwischen den Objekten liegt Fahrzeit. Je weiter ein Objekt vom Kerngebiet entfernt ist, desto schwieriger wird es, eine verlässliche Zusage zu machen – besonders bei Dauerschneefall, wenn mehrfach nachgeräumt werden muss.",
          "Deshalb ist Nähe kein Marketingargument, sondern die Voraussetzung für Zuverlässigkeit. Ein Anbieter, der zu weit entfernt plant, wird genau dann nicht pünktlich sein, wenn es darauf ankommt.",
        ],
      },
      {
        h2: "Die Lösung: dichte Touren im Bremer Stadtgebiet",
        p: [
          "Wir bauen unsere Touren bewusst dicht. Objekte, die räumlich zusammenliegen, werden gemeinsam geplant. Das bringt kürzere Wege, verlässlichere Zeiten und die Möglichkeit, bei anhaltendem Schneefall noch einmal nachzuarbeiten. Für Nachbarschaften und Eigentümergemeinschaften, die gemeinsam anfragen, ist das besonders interessant.",
        ],
        bullets: [
          "Bremen-Mitte, Neustadt, Östliche Vorstadt",
          "Findorff, Walle, Gröpelingen, Woltmershausen",
          "Schwachhausen, Horn-Lehe, Oberneuland, Borgfeld",
          "Hemelingen, Sebaldsbrück, Vahr, Osterholz",
          "Obervieland, Huchting",
          "Burglesum, Vegesack, Blumenthal",
          "Direkt angrenzendes Umland auf Anfrage",
        ],
      },
      {
        h2: "Anfragen aus dem Umland",
        p: [
          "Wenn Ihr Objekt außerhalb des Bremer Stadtgebiets liegt, fragen Sie trotzdem an. Je nach Fläche, Objektart und Lage lässt sich oft eine Lösung finden – gerade bei größeren Gewerbeflächen oder wenn mehrere Objekte in einer Nachbarschaft zusammenkommen. Wir geben Ihnen dazu eine ehrliche Einschätzung.",
        ],
      },
    ],
    steps: [
      { t: "Standort nennen", d: "Adresse und Objektart per Telefon, WhatsApp oder E-Mail." },
      { t: "Einschätzung", d: "Wir prüfen, ob das Objekt in die Tourenplanung passt." },
      { t: "Objektaufnahme", d: "Vor-Ort-Termin oder Beschreibung der Flächen." },
      { t: "Angebot", d: "Objektbezogenes Angebot für Saison oder Einzeleinsätze." },
    ],
    objects: [
      "Privatgrundstücke im Stadtgebiet",
      "Wohnanlagen und WEG",
      "Gewerbeobjekte und Betriebshöfe",
      "Handels- und Büroflächen",
      "Objekte im direkten Umland auf Anfrage",
    ],
    local:
      "Unser Standort liegt an der Flughafenallee 26 in 28199 Bremen. Von dort erreichen wir den Osten Bremens – Hemelingen, Sebaldsbrück, Vahr, Osterholz, Hastedt – besonders schnell, planen aber Touren im gesamten Stadtgebiet einschließlich Bremen-Nord.",
    faq: [
      { q: "In welchem Gebiet bieten Sie Winterdienst an?", a: "Im gesamten Bremer Stadtgebiet mit allen Stadtteilen sowie im direkt angrenzenden Umland. Für Objekte weiter außerhalb geben wir eine individuelle Einschätzung." },
      { q: "Bedienen Sie auch Bremen-Nord?", a: "Ja, Burglesum, Vegesack und Blumenthal gehören zum Einsatzgebiet." },
      { q: "Nennen Sie konkrete Umlandorte?", a: "Wir listen bewusst nur Gebiete, die wir tatsächlich bedienen. Für Ihr Objekt im Umland klären wir die Machbarkeit direkt bei der Anfrage." },
      { q: "Ist eine gemeinsame Anfrage mit Nachbarn möglich?", a: "Ja. Mehrere Objekte in einer Nachbarschaft lassen sich in einer Tour bündeln – das ist planerisch und preislich oft günstiger." },
      { q: "Wie schnell sind Sie vor Ort?", a: "Das hängt von Lage und Wetterlage ab. Im Kerngebiet planen wir feste Zeitfenster, die wir bei der Objektaufnahme konkret benennen." },
    ],
    related: [
      R("Einsatzgebiet", "/einsatzgebiet", "Stadtteile im Überblick."),
      R("Winterdienst Bremen", "/winterdienst-bremen", "Leistungen im Stadtgebiet."),
      R("Winterdienst Privat", "/winterdienst-bremen-privat", "Für Haus und Grundstück."),
      R("Winterdienst Gewerbe", "/winterdienst-bremen-gewerbe-hausverwaltung", "Für Unternehmen."),
      R("Kontakt", "/kontakt", "Telefon, WhatsApp, E-Mail."),
      R("Über uns", "/ueber-uns", "Wer hinter Bremer Schneemann steht."),
    ],
  },

  {
    slug: "/gehweg-winterdienst-bremen",
    title: "Gehweg Winterdienst Bremen | Gehwege räumen und streuen",
    description:
      "Gehweg-Winterdienst in Bremen: Gehwege räumen, streuen und von Eis befreien. Räum- und Streupflicht am Gehweg zuverlässig übernommen – Angebot auf Anfrage.",
    label: "/ Gehwege",
    service: "Gehweg Winterdienst Bremen",
    h1Lines: ["Gehweg-Winterdienst", "Bremen – Räumpflicht", "zuverlässig erfüllt."],
    intro:
      "Der Gehweg vor Ihrem Grundstück ist die Fläche mit dem höchsten Risiko und der klarsten Pflicht. Wir räumen und streuen Gehwege in Bremen – auf nutzbarer Breite, zu festen Zeiten und mit dem richtigen Streugut.",
    image: IMG.clearedWalk,
    sections: [
      {
        h2: "Der Gehweg: kleine Fläche, große Verantwortung",
        p: [
          "Kaum eine Fläche am Grundstück wird so intensiv genutzt wie der Gehweg – und kaum eine ist so eindeutig zugeordnet. In Bremen sind Anlieger verpflichtet, den Gehweg entlang ihres Grundstücks bei Schnee zu räumen und bei Glätte zu streuen. Das gilt auch, wenn der Gehweg öffentlich ist.",
          "Praktisch bedeutet das: Der Weg muss auf einer Breite frei sein, auf der sich Menschen begegnen können – nicht nur eine Schaufelspur. Und er muss früh frei sein, weil Schulweg, Berufsverkehr und Zustelldienste am Morgen beginnen. Genau das macht die Eigenleistung so schwierig, wenn man selbst früh zur Arbeit muss.",
        ],
      },
      {
        h2: "Das Problem: Teilräumung, falsches Streugut, verdichteter Schnee",
        p: [
          "Drei Fehler sehen wir regelmäßig. Erstens die zu schmale Räumung: Der Weg wirkt geräumt, ist aber praktisch nicht nutzbar, besonders mit Kinderwagen, Rollator oder Rollstuhl. Zweitens verdichteter Schnee: Wird nicht früh geräumt, läuft die Schicht fest und wird zur Eisplatte. Drittens Salz auf allem: Auf historischem Klinker und in der Nähe von Straßenbäumen ist Streusalz nicht die beste Wahl – und in vielen Fällen auch nicht erlaubt.",
          "Dazu kommt die Grauzone an den Rändern: Grundstückskante, Bordsteinübergang zur Fahrbahn, Einmündung einer Einfahrt. Dort entsteht Glätte besonders häufig, weil Wasser zusammenläuft.",
        ],
      },
      {
        h2: "Die Lösung: definierte Breite, definierte Zeit, passendes Streugut",
        p: [
          "Wir legen bei der Objektaufnahme fest, welche Gehwegabschnitte in welcher Breite geräumt werden und wo das Streugut zum Einsatz kommt. Auf empfindlichen Belägen und in Baumscheibennähe arbeiten wir abstumpfend mit Sand oder Granulat, auf robusten Flächen auch auftauend.",
        ],
        bullets: [
          "Gehwegabschnitt entlang des Grundstücks vollständig räumen",
          "Bordsteinübergänge und Querungen freihalten",
          "Einmündungen von Einfahrten mit erfassen",
          "Streugut passend zu Belag und Umgebung",
          "Nachräumen bei anhaltendem Schneefall",
          "Schneelagerung ohne Blockade von Gullys und Querungen",
        ],
      },
      {
        h2: "Gehweg und Hauseingang als Einheit denken",
        p: [
          "Ein geräumter Gehweg nützt wenig, wenn der Weg zur Haustür oder die Stufen zum Eingang glatt bleiben. In der Praxis beauftragen die meisten Kunden daher Gehweg, Zugangsweg und Eingangsbereich gemeinsam. Das ist auch planerisch sinnvoll: Wir sind ohnehin vor Ort und können die kritischen Punkte in einem Durchgang abarbeiten.",
        ],
      },
    ],
    steps: [
      { t: "Abschnitt festlegen", d: "Länge, Breite und Belag des Gehwegs bestimmen." },
      { t: "Zeitfenster", d: "Wann muss der Weg nutzbar sein – Schulweg, Berufsverkehr." },
      { t: "Räumen", d: "Vollständige Breite, Schnee auf festgelegte Lagerfläche." },
      { t: "Streuen", d: "Kritische Punkte – Querungen, Senken, Einmündungen." },
    ],
    objects: [
      "Gehwege an Einfamilienhäusern",
      "Gehwege an Mehrfamilienhäusern",
      "Gehwege entlang Gewerbegrundstücken",
      "Zugangswege zur Haustür",
      "Wege zu Müll- und Fahrradplätzen",
      "Querungen und Bordsteinabsenkungen",
    ],
    local:
      "In Bremer Altbauquartieren wie der Östlichen Vorstadt, Findorff oder Walle sind Gehwege oft schmal, gepflastert und von Baumscheiben unterbrochen – hier zählt sorgfältige Handarbeit. In neueren Wohngebieten in Horn-Lehe, Oberneuland oder Borgfeld sind die Wege breiter und maschinell gut zu bearbeiten.",
    faq: [
      { q: "Wie breit wird der Gehweg geräumt?", a: "So breit, dass er sicher nutzbar ist und Begegnungsverkehr möglich bleibt. Die konkrete Breite legen wir bei der Objektaufnahme fest." },
      { q: "Bin ich als Mieter oder Eigentümer verantwortlich?", a: "Grundsätzlich trifft die Pflicht den Anlieger, kann aber mietvertraglich übertragen sein. Unabhängig davon können wir die Leistung für Sie übernehmen." },
      { q: "Verwenden Sie Salz auf dem Gehweg?", a: "Nur wo es sinnvoll und zulässig ist. In Baumscheibennähe und auf empfindlichem Pflaster arbeiten wir bevorzugt mit Sand oder Granulat." },
      { q: "Wird auch der Weg zur Haustür geräumt?", a: "Auf Wunsch ja – die meisten Kunden beauftragen Gehweg, Zugangsweg und Eingang gemeinsam." },
      { q: "Was passiert bei Schneefall am Nachmittag?", a: "Bei anhaltendem oder erneutem Schneefall räumen wir nach. Den Umfang legen wir im Angebot fest." },
    ],
    related: [
      R("Winterdienst Privat", "/winterdienst-bremen-privat", "Für Haus und Grundstück."),
      R("Treppen & Eingänge", "/treppen-winterdienst-bremen", "Zugang zur Haustür."),
      R("Streudienst Bremen", "/streudienst-bremen", "Glätte am Gehweg."),
      R("Schneeräumung Bremen", "/schneeraeumung-bremen", "Räumtechnik und Vorgehen."),
      R("Eisbeseitigung Bremen", "/eisbeseitigung-bremen", "Festgefrorenes Eis lösen."),
      R("Zufahrten", "/zufahrten-winterdienst-bremen", "Einmündung und Einfahrt."),
    ],
  },
];
